<div
  class="sub-nav-item"
  (click)="navItemSelected(); $event.stopPropagation()"
  [ngClass]="{
    'sub-active': viewModel.isNavItemActive$ | async
  }">
  {{ subItem?.name }}
</div>
